import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ஸ்தோத்திரங்கள்</h1>
<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>     பட்டியல் 
    </mat-expansion-panel-header>
    <div class="div3">
      <ol>
        <li>ஆபதுத்தாரண ஸ்தோத்ரம்</li>
        <li>ஹயக்ரீவ ஸ்தோத்ரம்
        </li>
        <li>கோபாலவிம்சதி:</li>
        <li>தேவநாயக பஞ்சாசத்</li>
        <li>அச்யுதசதகம் ரகுவீர கத்யம்
        </li>
        <li>கருட தண்டகம்</li>
        <li>ஸ்ரீஸ்துதி:</li>
        <li>வரதராஜபஞ்சாசத்</li>
        <li>வேகாஸேது ஸ்தோத்ரம்</li>
        <li>அஷ்டபுஜாஷ்டகம்</li>
        <li>காமாஸிகாஷ்டகம்</li>
        <li>பரமார்த்த ஸ்துதி:</li>
        <li>சரணாகதி தீபிகா</li>
        <li>ஷோடசாயுத ஸ்தோத்ரம்</li>
        <li>கருடபஞ்சாசது</li>
        <li>யதிராஜ ஸப்ததி:</li>
        <li>வைராக்ய பஞ்சகம்</li>
        <li>தயாசதகம்</li>
        <li>தேஹளீச ஸ்துதி:</li>
        <li>ந்யாச தசகம்</li>
        <li>ந்யாச திலகம்</li>
        <li>பூஸ்துதி:</li>
        <li>கோதா ஸ்துதி:</li>
        <li>தசாவதார ஸ்தோத்ரம்</li>
        <li>பகவத் த்யாந சோபாநம்</li>
        <li>ஸுதர்ஸநாஷ்டகம்</li>
        <li>ந்யாசவிம்சதி</li>
        <li>அபீதிஸ்தவம்</li>
        <li>தாடீ பஞ்சகம்</li>
        <li>ஹரித திலகம்</li>
        <li>த்ரமிடோபநிஷத் சாரம்</li>
        <li>தத் தாத்பர்ய ரத்நாவளி:
        </li>
        <li>திவ்யஸூரி ஸ்தோத்ரம்</li>
        <li>தேசிக மங்களாசாசனம்</li>
        <li>தேசிக ப்ரார்த்தநாஷ்டகம்
        </li>
        <li>தேசிக திநசர்யா</li>
        <li>தேசிக ப்ரபத்தி:</li>
        <li>ஸப்ததி ரத்நமாலிகா</li>
        <li>யஜ்ஞோபவீத ப்ரதிஷ்டா</li>
       </ol>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>01-ஆபதுத்தாரண ஸ்தோத்ரம்      
    </mat-expansion-panel-header>
    <div class="div3">
      ஆபதாமபஹர்த்தாராம் <br>தாதாரம் ஸர்வஸம்பதாம்|<br>
  லோகாபிராமம் ஸ்ரீராமம் <br>பூயோபூயோ நமாம்யஹம்||				1<br><br>
  ஆர்த்தாநாம் ஆர்த்திஹந்தாரம்<br> பீதாநாம் பீதிநாஶநம்|<br>
  த்விஷதாம் காலதண்டம் தம்<br> ராமச்சந்த்ரம் நமாம்யஹம்||			2<br><br>
  நம: கோதண்டஹஸ்தாய<br> ஸந்தீக்ருத ஶராய ச|<br>
  கண்டிதாகில தைத்யாய<br> ராமாயஆபந்நிவாரிணே||				3<br><br>
  ராமாய ராமபத்ராய<br> ராமசந்த்ராய வேதஸே|<br>
  ரகுநாதாய நாதாய<br> ஸீதாயா: பதயே நம:||						4<br><br>
  அக்ரத: ப்ருஷ்டதஶ்சைவ<br> பார்ஶ்வதஶ்ச மஹாபலௌ|<br>
  ஆகர்ணபூர்ண தந்வாநௌ<br> ரக்ஷேதாம் ராம லக்ஷ்மணௌ||		5<br><br>
  ஸந்நத்த: க்வசீ கட்கீ<br> சாபபாணதரோ யுவா|<br>
  கச்சந் மமாக்ரதோ நித்யம்<br> ராம: பாது ஸலக்ஷ;மண:||			6<br><br>
  அச்யுதாநந்த கோவிந்த<br> நமோச்சாரண பேஷஜாத்|<br>
  நஶ;யந்தி ஸகலா ரோகா:<br> ஸத்யம் ஸத்யம் வதாம்யஹம்||		7<br><br>
  ஸத்யம் ஸத்யம் புநஸ்ஸத்யம்<br> உத்ருத்ய புஜமுச்யதே|<br>
  வேதாஶ்ஶhஸ்த்ரம் பரம் நாஸ்தி<br> ந தைவம் கேசவாத்பரம்||		8<br><br>
  ஶரீரே ஜர்ஜரீபூதே<br> வ்யாதிக்ரஸ்தே களேபரே|<br>
  ஒளஷதம் ஜாஹ்நவீதோயம் <br>வைத்யோ நாராயணோ ஹரி:||		9<br><br>
  ஆலோட்ய ஸர்வஶhஸ்த்ராணி<br> விசார்யச புந: புந:|<br>
  இதமேகம் ஸுநிஷ்பந்நம் <br>த்யேயோ நாராயணோ ஹரி:||			10<br><br>
  காயேனவாசா மனஸேந்திரியைர்வா<br>
    புத்யாத்மனாவா ப்ரக்ருதே ஸ்வபாவாத் |<br>
  கரோமி யத்யத் ஸகலம் பரஸ்மை <br>
    நாராயணாயேதி ஸமர்ப்பயாமி ||							11<br><br>
  யதக்ஷர பதப்ரஷ்டம் <br>மாத்ராஹீநந்து யத்பவேத்|<br>
  தத்ஸர்வம் க்ஷம்யதாம்<br> தேவ நாராயண நமோஅஸ்துதே||		12<br><br>
  விஸர்க்க பிந்து மாத்ராணி<br> பதபாதாக்ஷராணி ச|<br>
  ந்யூநானி ச அதிரிக்தாநி<br> க்ஷமஸ்வ புருஷோத்தம||				13
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>02. ஸ்ரீக்ருஷ்ணாஷ்டகம்      
    </mat-expansion-panel-header>
    <div class="div3">
      <h3>ஸ்ரீக்ருஷ்ணாஷ்டகம்</h3>
      வஸுதேவ ஸுதந்தேவம்<br />
      கம்ஸசாணூர மர்தனம்<br />
      தேவகீ பரமானந்தம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 1<br />
      <br />
      அதஸீபுஷ்ப ஸங்காசம்<br />
      ஹாரநூபுர சோபனம்<br />
      ரத்னகங்கண கேயூரம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 2<br />
      <br />
      குடிலாலக ஸம்யுக்தம்<br />
      பூர்ண சந்த்ர நிபானனம்<br />
      விலஸத் குண்டல தரம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 3<br />
      <br />
      மந்தாரகந்த ஸம்யுக்தம்<br />
      சாருஹாஸம் சதுர்புஜம்<br />
      பர்ஹிபிஞ்சாவ சூடாங்கம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 4<br />
      <br />
      உத்புல்பத்ர பத்ராக்ஷம்<br />
      நீலஜீமூத ஸந்நிபம்<br />
      யாதாவானாம் சிரோரத்னம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 5<br />
      <br />
      ருக்மணிகேளி ஸம்யுக்தம்<br />
      பீதாம்பர சுஸோபிதம்<br />
      அவாப்த துளசீ கந்தம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 6<br />
      <br />
      கோபிகானாம் குசஸ்த்வந்த<br />
      குங்குமாங்கித வக்ஷஸம்<br />
      ஸ்ரீநிகேதம் மஹேஷ்வாஸம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 7<br />
      <br />
      ஸ்ரீவத்சாங்கம் மஹோரஸ்கம்<br />
      வனமாலா விராஜிதம்<br />
      சங்கசக்ர தரம் தேவம்<br />
      க்ருஷ்ணம் வந்தே ஜகத்குரும் - 8 <br />
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>03. ஸ்ரீவிஷ்ணு ஸஹஸ்ரநாமம்  
    </mat-expansion-panel-header>
    <div class="div3">
      <p style="text-align: center">ஹரி: ஓம்</p>
  ஸ்ரீவிஷ்ணு ஸஹஸ்ரநாம ஸ்தோத்ரம்<hr class="style2">
  ஸ்ரீமான் வேங்கட நாதார்ய:<br /> கவிதார்கிக கேஸரி<br />
  வேதாந்தாச்சார்ய வர்யோமே<br /> ஸந்நிதத்தாம் ஸதாஹ்ருதி|| 1<br /><br />
  ஶுக்லாம்பரதரம் விஷ்ணும்<br /> ஶஶிவர்ணம் சதுர்புஜம்|<br />
  ப்ரஸந்நவதனம் த்யாயேத்<br /> ஸர்வவிக்நோபஶாந்தயே|| 2<br /><br />
  யஸ்ய த்விரத வக்த்ராத்யா:<br /> பாரிஷத்யா: பரஸ்ஶதம்|<br />
  விக்நம் நிக்நந்தி ஸததம்<br /> விஷ்வக்ஸேநம் தமாச்ரயே|| 3<br /><br />
  வ்யாஸம் வஸிஷ்ட நப்தாரம்<br /> ஶக்தே: பௌத்ரமகல்மஷம்|<br />
  பராஶராத்மஜம் வந்தே<br /> சுகதாதம் தபோநிதிம் || 4<br /><br />
  வ்யாஸாய விஷ்ணுரூபாய<br /> வ்யாஸரூபாய விஷ்ணவே|<br />
  நமோவை ப்ரஹ்மநிதயே<br /> வாஸிஷ்டாய நமோநம:|| 5<br /><br />
  அவிகாராய சுத்தாய<br /> நித்யாய பரமாத்மநே|<br />
  ஸதைக ரூப ரூபாய<br /> விஷ்ணவே ஸர்வஜிஷ்ணவே|| 6<br /><br />
  யஸ்ய ஸ்மரண மாத்ரேண<br /> ஜந்ம ஸம்ஸார பந்தநாத்|<br />
  விமுச்யதே நமஸ்தஸ்மை<br /> விஷ்ணவே ப்ரபவிஷ்ணவே|| 7<br /><br />
  ஓம் நமோ விஷ்ணவே ப்ரபவிஷ்ணவே||<br /><br />
  ஸ்ரீவைசம்பாயந உவாச -<br /><br />
  ச்ருத்வா தர்மாந்நசேஷேண<br /> பாவநாநிச ஸர்வச:|<br />
  யுதிஷ்டிரஸ்சாந்தநவம் <br />புநரேவாப்யபாஷத|| 1<br /><br />
  யுதிஷ்டிர உவாச-<br /><br />
  கிமேகம் தைவதம் லோகே<br /> கிம்வாப்யேகம் பராயணம்|<br />
  ஸ்துவந்த: கம்கமர்சந்த:<br /> ப்ராப்நுயுர்மாநவா: சுபம்|| 2<br /><br />
  கோதர்ம: ஸர்வ தர்மாணாம்<br /> பவத: பரமோ மத:|<br />
  கிம்ஜபந் முச்யதே ஜந்துர்<br /> ஜந்மஸம்ஸார பந்தநாத்|| 3<br />
  <br />
  ஸ்ரீபீஷ்ம உவாச-<br /><br />
  ஜகத்ப்ரபும் தேவ தேவம் <br />அநந்தம் புருஷோத்தமம் |<br />
  ஸ்துவந்நாம ஸஹஸ்ரேண<br /> புருஷ ஸதோத்தித:|| 4<br /><br />
  தமேவ சார்ச்சயந்நித்யம்<br /> பக்த்யா புருஷமவ்யயம் |<br />
  த்யாயந் ஸ்துவந் நமஸ்யம்ஸ்ச <br />யஜமாநஸ் தமேவச || 5<br /><br />
  அநாதிநிதநம் விஷ்ணும்<br /> ஸர்வலோகமஹேஸ்வரம் |<br />
  லோகாத்யக்ஷம் ஸ்துவந்நித்யம் <br />ஸர்வதுக்காதிகோ பவேத் || 6<br /><br />
  ப்ரஹ்மண்யம் ஸர்வதர்மஜ்ஞம்<br /> லோகாநாம் கீர்த்தி வர்த்தநம் |<br />
  லோகநாதம் மஹத்பூதம் <br />ஸர்வபூத பவோத்பவம் || 7<br /><br />
  ஏஷமே ஸர்வதர்மாணாம்<br /> தர்மோதி கதமோமத: |<br />
  யத்பக்த்யா புண்டரீகாக்ஷம்<br /> ஸ்தவைரர்ச்சேந் நரஸ்ஸதா || 8<br /><br />
  பரமம்யோ மஹத்தேஜ:<br /> பரமம்யோ மஹத்தப: |<br />
  பரமம்யோ மஹத்ப்ரஹ்ம<br /> பரமம் ய:பராயணம் || 9<br /><br />
  பவித்ராணாம் பவித்ரம்யோ<br /> மங்களாநாம்ச மங்களம் |<br />
  தைவதம் தேவதாநாஞ்ச<br /> பூதாநாம் யோஅவ்யய: பிதா || 10<br /><br />
  யதஸ்ஸர்வாணி பூதாநி<br /> பவந்த்யாதி யுகாகமே |<br />
  யஸ்மிம்ஶ்ச ப்ரலயம்யாந்தி<br /> புநரேவ யுகக்ஷயே || 11<br /><br />
  தஸ்யலோகப்ரதாநஸ்ய<br /> ஜகந்தாதஸ்ய பூபதே |<br />
  விஷ்ணோர்நாம ஸஹஸ்ரம்மே<br /> ச்ருணுபாபபயாபஹம் || 12<br /><br />
  யாநி நாமாநி கௌணாநி<br /> விக்யாதாநி மஹாத்மந: |<br />
  ரிஷிபிர் பரிகீதாநி<br /> தாநி வக்ஷ்யாமி பூதயே || 13<br /><br />
  ரிஷிர் நாம் நாம் ஸஹஸ்ரஸ்ய<br /> வேதவ்யாஸோ மஹாமுநி: |<br />
  சந்தோநுஷ்டுப் ததா தேவோ<br /> பகவாந் தேவகீஸுத: || 14<br /><br />
  அம்ருதாம் சூத்பவோ பீஜம்<br /> சக்திர் தேவகிநந்தந: |<br />
  திரிஸாமா ஹ்ருதயம் தஸ்ய<br /> சாந்த்யர்த்தே விநியுஜ்யதே || 15<br /><br />
  விஷ்ணும்ஜிஷ்ணும் மஹாவிஷ்ணும்<br /> ப்ரபவிஷ்ணும் மஹேச்வரம் |<br />
  அநேகரூபம் தைத்யாந்தம்<br /> நமாமி புருஷோத்தமம் || 16<br /><br />
  அஸ்ய ஸ்ரீ விஷ்ணோர்<br /> திவ்ய ஸஹஸ்ரநாம<br /> ஸ்தோத்ர மஹாமந்த்ரஸ்ய| <br /><br />
  ஸ்ரீவேதவ்யாஸோ பகவாந் ருஷி:|<br /><br />
  அநுஷ்டுப் சந்த:| <br /><br />
  ஸ்ரீமஹாவிஷ்ணு பரமாத்மா<br /> ஸ்ரீமந்நாராயணோ தேவதா| <br /><br />
  அம்ருதாம் சூத்பவோ<br /> பாநுரிதி பீஜம்| <br /><br />
  தேவகீ நந்தந<br /> ஸ்ரஷ்டேதி சக்தி:| <br /><br />
  உத்பவ: க்ஷோபணோ<br /> தேவ இதி பரமோமந்த்ர:| <br /><br />
  சங்கப்ருந்நந்தகீ<br /> சக்ரீதி கீலகம்| <br /><br />
  சார்ங்கதந்வா<br /> கதாதர இத்யஸ்த்ரம்| <br /><br />
  ரதாங்கபாணி<br /> ரக்ஷோப்ய இதி நேத்ரம்| <br /><br />
  த்ரிஸாமா ஸாமகஸ் <br />ஸாமேதி கவசம்| <br /><br />
  ஆநந்தம் பரப்ரஹ்மேதி யோநி:| <br /><br />
  ருதுஸ்ஸுதர்சந:<br /> கால இதிதிக்பந்த:| <br /><br />
  ஸ்ரீவிச்வரூப<br /> இதி த்யாநம்| <br />
  <br />
  ஸ்ரீமஹாவிஷ்ணு ப்ரீத்யர்த்தே<br /> ஸ்ரீஸஹஸ்ரநாம ஜபே விநியோக:||<br /><br />
  <hr class="style2">
  <p style="text-align:center">த்யாநம்:</p>
  <hr class="style2">
  க்ஷீரோதந்வத்ப்ரதேசே<br /> சுசிமணிவிலஸத் ஸைகதே<br /> மௌக்திகாநாம்<br />
  மாலாக்லுப்தா<br /> ஸநஸ்த: ஸ்படிகமணிநிபைர்<br /> மௌக்திகைர் மண்டிதாங்க:|<br /><br />
  சுப்ரை ரப்ரை ரதப்ரை<br /> ருபரி விரசிதைர்<br /> முக்தபீயூஷவர்ஷை: |<br />
  ஆநந்தீந: புநீயா<br /> தரிநளிந கதா<br /> சங்கபாணிர் முகுந்த: || 1<br />
  <br />
  பூப்பாதௌ யஸ்ய நாபிர் <br />வியத ஸுரநிலஸ்சந்த்ரஸூர்யௌச நேத்ரே<br />
  கர்ணாவாசா: சிரோ த்யௌர்<br /> முகமபி தஹநோ யஸ்ய வாஸ்தேயமப்தி:|<br /><br />
  அந்தஸ்தம் யஸ்ய விஸ்வம்<br /> ஸுரநர கககோ போகிகந்தர்வ தைத்யை:<br />
  சித்ரம் ரம் ரம்யதே <br />தம்த்ரிபுவந வபுஷம் விஷ்ணுமீசம் நமாமி || 2<br /><br />
  ஓம் நமோ பகவதே வாசுதேவாயா|<br /><br />
  சாந்தாகாரம் புஜகசயநம்<br /> பத்மநாபம் ஸுரேசம்<br />
  விஸ்வாதாரம் ககந ஸத்ருசம்<br /> மேகவர்ணம் சுபாங்கம் | <br /><br />
  லக்ஷ்மீகாந்தம் கமலநயநம்<br /> யோகிஹ்ருத் த்யாநகம்யம்<br />
  வந்தேவிஷ்ணும் பவபயஹரம்<br /> ஸர்வலோகைகநாதம் || 3<br /><br />
  மேகச்யாமம் பீதகௌசேயவாஸம் <br />
  ஸ்ரீவத்ஸாங்கம்<br /> கௌஸ்துபோத்பாஸிதாங்கம்|<br /><br />
  புண்யோபேதம் புண்டரீகாயதாக்ஷம் <br />
  விஷ்ணும்வந்தே ஸர்வலோகைக நாதம்|| 4<br /><br />
  ஸசங்க சக்ரம் ஸகிரீட குண்டலம் <br />
  ஸபீதவஸ்த்ரம் ஸரஸீருஹேக்ஷணம்|<br /><br />
  ஸஹாரவக்ஷ: ஸ்தலசோபி கௌஸ்துபம் <br />
  நமாமி விஷ்ணும் சிரஸா சதுர்புஜம்.|| 5<br /><br />
  சாயாயாம் பாரிஜாதஸ்ய<br /> ஹேமஸிம்ஹாஸநோபரி |<br /><br />
  ஆஸீனமம்புதச்யாம<br /> மாயதாக்ஷமலங்க்ருதம் || <br /><br />
  சந்த்ரானனம் சதுர்பாஹும் <br />ஸ்ரீவத்ஸாங்கிதவக்ஷஸம் |<br />
  ருக்மிணீஸத்யபாமாப்யாம்<br /> ஸஹிதம் ஸ்ரீக்ருஷ்ணமாச்ரயே || 6<br />
  <br />
  <hr class="style2">
  <p style="text-align:center">நாம ஸஹஸ்ர ப்ராரம்ப:|</p>
    <hr class="style2">
  
  ஹரி: ஓம்|<br /><br />
  விச்வம் விஷ்ணுர் வஷட்காரோ<br /> பூதபவ்ய பவத்ப்ரபு:|<br />
  பூதக்ருத் பூதப்ருத்பாவோ<br /> பூதாத்மா பூதபாவந:|| 1<br /><br />
  பூதாம்மா பரமாத்மா ச<br /> முக்தாநாம் பரமாகதி: |<br />
  அவ்யய: புருஷஸ் ஸாக்ஷீ<br /> க்ஷேத்ரஜ்ஞோக்ஷர ஏவ ச|| 2<br /><br />
  யோகோ யோகவிதாம் நேதா<br /> ப்ரதாந புருஷேஸ்வர: |<br />
  நாரஸிம்ஹவபு: ஸ்ரீமாந் <br />கேசவ: புருஷோத்தம: || 3<br />
  <br />
  ஸர்வ: ஸர்வச் சிவஸ் ஸ்தாணுர் <br />பூதாதிர் நிதிரவ்யய: |<br />
  ஸம்பவோ பாவநோ பர்த்தா<br /> ப்ரபவ: ப்ரபுரீச்வர: || 4<br /><br />
  ஸ்வயம்பூ ஸம்புராதித்ய:<br /> புஷ்கராக்ஷோ மஹாஸ்வந:|<br />
  அநாதிநிதநோ தாதா<br /> விதாதா தாதுருத்தம: || 5<br /><br />
  அப்ரமேயோ ஹ்ருஷீகேச: <br />பத்மநாபோ அமரப்ரபு: |<br />
  விச்வகர்மா மநுஸ்த்வஷ்டா<br /> ஸ்தவிஷ்ட ஸ்தவிரோ த்ருவ:|| 6<br /><br />
  அக்ராஹ்யச் சாச்வத: க்ருஷ்ணோ<br /> லோஹிதாக்ஷ: ப்ரதர்தந:|<br />
  ப்ரபூதஸ் த்ரிககுத்தாம<br /> பவித்ரம் மங்களம் பரம்|| 7<br /><br />
  ஈசாந: ப்ராணத: ப்ராணோ<br /> ஜ்யேஷ்டச் ச்ரேஷ்ட ப்ராஜாபதி:|<br />
  ஹிரண்யகர்போ பூகர்போ<br /> மாதவோ மதுஸூதந:|| 8<br /><br />
  ஈச்வரோ விக்ரமீ தந்வீ <br />மேதாவீ விக்ரம: க்ரம:|<br />
  அநுத்தமோ துராதர்ஷ:<br /> க்ருதஜ்ஞ: க்ருதிராத்மவாந்|| 9<br /><br />
  ஸுரேசஸ் சரணம் சர்ம<br /> விச்வரேதா: ப்ரஜாபவ:|<br />
  அஹஸ் ஸம்வத்ஸரோவ்யாள: <br />ப்ரத்யயஸ் ஸர்வதர்சந:|| 10<br /><br />
  அஜஸ் ஸர்வேச்வரஸ் ஸித்தஸ்<br /> ஸித்திஸ் ஸர்வாதிரச்யுத:|<br />
  வ்ருஷாகபிரமேயாத்மா<br /> ஸர்வயோக விநிஸ்ருத:|| 11<br /><br />
  வஸுர் வஸுமநாஸ் ஸத்யஸ்<br /> ஸமாத்மா ஸம்மிதஸ் ஸம:|<br />
  அமோக: புண்டாPகாக்ஷோ<br /> வ்ருஷகர்மா வ்ருஷாக்ருதி:|| 12<br /><br />
  ருத்ரோ பஹுசிரா பப்ருர்<br /> விச்வயோநிஸ்சுசிச்ரவா:|<br />
  அம்ருதஸ்சாச்வதஸ்தாணுர்<br /> வராரோஹோ மஹா தபா:|| 13<br /><br />
  ஸர்வகஸ் ஸர்வவித்பாநுர்<br /> விஷ்வக்ஸேநோ ஜநார்த்தந|:<br />
  வேதோ வேதவிதவ்யங்கோ<br /> வேதாங்கோ வேதவித்கவி:|| 14<br /><br />
  லோகாத்யக்ஷஸ் ஸுராத்யக்ஷோ<br /> தர்மாத்யக்ஷ: க்ருதாக்ருத:|<br />
  சதுராத்மா சதுர்வ்யூகச் <br />சதுர்தம்ஷ்ட்ரச் சதுர்புஜ:|| 15<br /><br />
  ப்ராஜிஷ்ணுர் போஜனம் போக்தா <br />ஸஹிஷ்ணுர் ஜகதாதிஜ:|<br />
  அநகோ விஜயோ ஜேதா<br /> விச்வயோநி: புநர்வஸு:|| 16<br /><br />
  உபேந்த்ரோ வாமந: ப்ராம்சு:<br /> அமோகச் சுசிரூர்ஜித:|<br />
  அதீந்திரஸ் ஸங்க்ரஹஸ் ஸர்கோ<br /> த்ருதாத்மா நியமோ யம:|| 17<br /><br />
  வேத்யோ வைத்யஸ் ஸதாயோகீ<br /> வீரஹா மாதவோ மது:|<br />
  அதீந்த்ரியோ மஹாமாயோ<br /> மஹோத்ஸாஹோ மஹாபல:|| 18<br /><br />
  மஹாபுத்திர் மஹாவீர்யோ<br /> மஹாசக்திர் மஹாத்யுதி:|<br />
  அநிர்தேச்யவபு: ஸ்ரீமாந்<br /> அமேயாத்மா மஹாத்ரித்ருத்|| 19<br /><br />
  மஹேஷ்வாஸோ மஹீபர்த்தா<br /> ஸ்ரீநிவாஸ: ஸதாம்கதி:|<br />
  அநிருத்தஸ் ஸுராநந்தோ<br /> கோவிந்தோ கோவிதாம்பதி:|| 20<br /><br />
  மரீசிர் தமநோஹம்ஸஸ்<br /> ஸுபர்ணோ புஜகோத்தம:|<br />
  ஹிரண்யநாபஸ் ஸுதபா: <br />பத்மநாப: ப்ரஜாபதி:|| 21<br /><br />
  அம்ருத்யுஸ் ஸர்வத்ருக்ஸிம்ஹஸ்<br /> ஸந்தாதா ஸந்திமாந்ஸ்திர:|<br />
  அஜோ துர்மர்ஷணச் சாஸ்தா<br /> விச்ருதாத்மா ஸுராரிஹா|| 22<br /><br />
  குருர்குருதமோ தாம<br /> ஸத்யஸ் ஸத்யபராக்ரம:|<br />
  நிமிஷோ நிமிஷஸ் ஸ்ரக்வீ <br />வாசஸ்பதி ருதாரதீ:|| 23.<br /><br />
  அக்ரணீர் க்ராமணீ: ஸ்ரீமாந் <br />ந்யாயோ நேதா ஸமீரண:|<br />
  ஸஹஸ்ர மூர்த்தா விச்வாத்மா<br /> ஸஹஸ்ராக்ஷஸ் ஸஹஸ்ரபாத்|| 24 <br /><br />
  ஆவர்த்தநோ நிவ்ருத்தாத்மா<br /> ஸம்வ்ருத: ஸம்ப்ரமர்த்தந:|<br />
  அஹஸ்ஸம்வர்த்தகோவஹ்நி <br />அநிலோ தரணீதர:|| 25<br /><br />
  ஸுப்ரஸாத: ப்ரஸந்நாத்மா<br /> விச்வஸ்ருக் விச்வபுக்விபு:|<br />
  ஸத்கர்த்தா ஸத்க்ருதஸ் ஸாதுர்<br /> ஜஹ்நுர் நாராயணோ நர:|| 26 <br /><br />
  அஸங்க்யேயோஸ்ர ப்ரமேயாத்மா<br /> விசிஷ்டச் சிஷ்டக்ருச்சுசி:| <br />
  சித்தார்த்தஸ் ஸித்தஸங்கல்பஸ் <br />ஸித்திதஸ் ஸித்திஸாதந:|| 27 <br /><br />
  வ்ருஷாஹீ வ்ருஷபோ விஷ்ணுர்<br /> வ்ருஷபர்வா வ்ருஷோதர:|<br />
  வர்த்தநோ வர்த்தமாநஸ்ச்ச<br />விவிக்தச் ச்ருதிஸாகர:|| 28<br /><br />
  ஸுபுஜோ துர்த்தரோ வாக்மீ<br /> மஹேந்த்ரோ வஸுதோவஸு:|<br />
  நைகரூபோ ப்ருஹத்ரூபச்<br /> சிபிவிஷ்ட: ப்ரகாசந:|| 29 <br /><br />
  ஓஜஸ்தேஜோத்யுதிதர:<br /> ப்ரகாசாத்மா ப்ரதாபந:|<br />
  ருத்தஸ் ஸ்பஷ்டாக்ஷரோ மந்த்ரச் <br />சந்த்ராம்சுர் பாஸ்கரத்யுதி:|| 30 <br /><br />
  அம்ருதாம் சூத்பவோ பாநு:<br /> சசபிந்துஸ் ஸுரேஸ்வர:|<br />
  ஒளஷதம் ஜகதஸ்ஸேதுஸ்<br /> ஸத்யதர்ம பராக்ரம:|| 31 <br /><br />
  பூதபவ்ய பவந்நாத: <br />பவந: பாவநோநல:|<br />
  காமஹா காக்ருத்காந்த:<br /> காம: காமப்ரத: ப்ரபு:|| 32 <br /><br />
  யுகாதிக்ருத் யுகாவர்த்தோ <br />நைகமாயோ மஹாசந:|<br />
  அத்ருச்யோ வ்யக்தரூபச்ச <br />ஸஹஸ்ரஜிதநந்தஜித்|| 33 <br />
  .<br />
  இஷ்டோ-விசிஷ்டஶ் ஶிஷ்டேஷ்டச்<br /> சிகண்டீ நஹுஷோவ்ருஷ:|<br />
  க்ரோதஹா க்ரோதக்ருத் கர்த்தா<br /> விச்வபாஹுர் மஹீதர:|| 34<br />
  .<br />
  அச்யுத: ப்ரதித: ப்ராண<br /> ப்ராணதோ வாஸவாநுஜ:|<br />
  அபாந்நிதிரதிஷ்டாந <br />மப்ரமத்த: ப்ரதிஷ்டித:|| 35<br /><br />
  ஸ்கந்தஸ் ஸ்கந்ததரோ துர்யோ<br /> வரதோ வாயுவாஹந:|<br />
  வாஸுதேவோ ப்ருஹத்ப்ாநுர்<br /> ஆதிதேவ: புரந்தர:|| 36 <br />
  .<br />
  அசோகஸ் தாரண: தாரஶ்<br /> சூரச்சௌரிர் ஜநேச்வர:|<br />
  அநுகூலஶ் ஶதாவர்த்த:<br /> பத்மீபத்மநிபேக்ஷண:|| 37 <br />
  <br />
  பத்மநாபோரவிந்தாக்ஷ<br /> பத்மகர்ப்பச் சரீரப்ருத்|<br />
  மஹர்த்திர் ருத்தோ வ்ருத்தாத்மா<br /> மஹாக்ஷோ கருடத்வஜ:|| 38 <br /><br />
  அதுலச் சரபோ பீமஸ் <br />ஸமயஜ்ஞோ ஹவிர்ஹரி:|<br />
  ஸர்வலக்ஷண லக்ஷண்யோ<br /> லக்ஷ;மீவாந் ஸமிதிஞ்ஜய:|| 39 <br />
  <br />
  விக்ஷரோ ரோஹிதோ மார்கோ<br /> ஹேதுர் தாமோதரஸ் ஸஹ:|<br />
  மஹீதரோ மஹாபாகோ<br /> வேகவாநமிதாசந:|| 40 <br />
  <br />
  கரணம் காரணம் கர்த்தா<br /> விகர்த்தா கஹநோகுஹ:|| 41 .<br />
  வ்யவஸாயோ வ்யவஸ்தாந: <br />ஸம்ஸ்தாநஸ் ஸ்தாநதோத்ருவ:|<br />
  பரத்திர் பரமஸ்பஷ்டஸ்<br /> துஷ்ட: புஷ்டச் சுபேக்ஷண:|| 42<br /><br />
  ராமோ விராமோ விரதோ<br /> மார்கோ நேயோ நயோ-நய:|<br />
  வீரச்சக்திமதாம் ச்ரேஷ்டோ<br /> தர்மோ தர்மவிதுத்தம:|| 43 <br /><br />
  வைகுண்ட: புருஷ: ப்ராண:<br /> ப்ராணத ப்ரணம ப்ருது:| <br />
  ஹிரண்யகர்ப்ப: சத்ருக்நோ<br /> வ்யாப்தோ வாயுரதோக்ஷஜ:|| 44 <br /><br />
  ருது:ஸுதர்சந:கால:<br /> பரமேஷ்டீ பரிக்ரஹ:|<br />
  உக்ரஸ் ஸம்வத்ஸரோ தக்ஷோ<br /> விச்ராமோ விச்வ தக்ஷிண:|| 45 <br />
  <br />
  விஸ்தார: ஸ்தாவரஸ்தாணு:<br /> ப்ரமாணம் பீஜமவ்யயம்|<br />
  அர்த்தோநர்த்தோ மஹாகோசோ<br /> மஹாபோகோ மஹாதந:|| 46 <br />
  <br />
  அநிர்விண்ண: ஸ்தவிஷ்டோபூர்<br /> தர்மயூபோ மஹாமக:|<br />
  நக்ஷத்ரநேமிர் நக்ஷத்ரீ <br />க்ஷம: க்ஷாம:ஸமீஹந:|| 47 <br />
  <br />
  யஜ்ஞ இஜ்யோ மஹேஜ்யச்ச<br /> க்ரது ஸத்ரம் சதாம்கதி:| <br />
  ஸர்வதர்சீ நிவ்ருத்தாத்மா<br /> ஸர்வஜ்ஞோ ஜ்ஞாநமுத்தமம்|| 48 <br />
  <br />
  ஸுவ்ரத: ஸுமுக: ஸூக்ஷ்ம:<br /> ஸுகோஷ: ஸுகத: ஸுஹ்ருத்| <br />
  மநோஹரோ ஜிதக்ரோதோ<br /> வீரபாஹுர் விதாரண:|| 49<br /><br />
  ஸ்வாபந: ஸ்வவசோ வ்யாபீ <br />நைகாத்மா நைககர்மக்ருத்|<br />
  வத்ஸரோ வத்ஸலோ வத்ஸீ<br /> ரத்நகர்போ தநேச்வர:|| 50 <br />
  <br />
  தர்மகுப் தர்மக்ருத் தர்மீ <br />ஸதஸத் க்ஷரமக்ஷரம்|<br />
  அவிஜ்ஞாதா ஸஹஸ்ராம்சுர்<br /> விதாதா க்ருதலக்ஷ;ண:|| 51 <br />
  <br />
  கபஸ்திநேமி: ஸத்வஸ்த:<br /> ஸிம்ஹோ பூதமஹேச்வர:|<br />
  ஆதிதேவோ மஹாதேவோ<br /> தேவேசோ தேவப்ருத்குரு:|| 52 <br />
  <br />
  உத்தரோ கோபதிர் கோப்தா<br /> ஜ்ஞாநகம்ய: புராதந:|<br />
  சாPரபூத ப்ருத்போக்தா<br /> கபீந்த்ரோ பூரிதக்ஷிண:|| 53 <br />
  <br />
  ஸோமபோ-ம்ருதப: ஸோம<br /> புருஜித் புருஸத்தம:|<br />
  விநயோஜய: ஸத்யஸந்தோ<br /> தசார்ஹ: ஸாத்வதாம் பதி:|| 54 <br />
  <br />
  ஜீவோ விநயிதாஸாக்ஷீ <br />முகுந்தோ-அமிதவிக்ரம:|<br />
  அம்போநிதிரநந்தாத்மா <br />மஹோததிசயோந்தக:|| 55 <br />
  <br />
  அஜோமஹார்ஹ: ஸ்வாபாவ்யோ<br /> ஜிதாமித்ர: ப்ரமோதந:|<br />
  ஆநந்தோ நந்தநோ நந்த:<br /> ஸத்யதர்மா த்ரிவிக்ரம:|| 56 <br />
  மஹர்ஷி: கபிலாச்சார்ய:<br /> க்ருதஜ்ஞோ மேதிநீபதி:|<br />
  த்ரிபதஸ் த்ரிதசாத்யக்ஷோ<br /> மஹாச்ருங்க: க்ருதாந்தக்ருத்|| 57 <br />
  <br />
  மஹாவராஹோ கோவிந்த:<br /> ஸுஷேண: கநகாங்கதீ|<br />
  குஹ்யோ கபீரோ கஹநோ<br /> குப்தச்சக்ர கதாதர:|| 58 <br />
  <br />
  வேதா:ஸ்வாங்கோ-ஜித:க்ருஷ்ணோ<br /> த்ருட: ஸங்கர்ஷணோச்யுத:|<br />
  வருணோ வாருணோ வ்ருக்ஷ:<br /> புஷ்கராக்ஷோ மஹாமநா:|| 59 <br />
  <br />
  பகவாந் பகஹா நந்தீ<br /> வநமாலீ ஹலாயுத: |<br />
  ஆதித்யோ ஜ்யோதிராதித்ய:<br /> ஸஹிஷ்ணுர் கதிஸத்தம:|| 60 <br />
  <br />
  ஸுதந்வா கண்டபரசுர்<br /> தாருணோ த்ரவிணப்ரத:|<br />
  திவிஸ்ப்ருக் ஸர்வத்ருக்வ்யாஸோ<br /> வாசஸ்பதிரயோநிஜ:|| 61 <br />
  <br />
  த்ரிஸாமா ஸாமக: ஸாம<br /> நிர்வாணம் பேஷஜம் பிஷக்|<br />
  ஸந்யாஸக்ருச் சம:சாந்தோ<br /> நிஷ்டாசாந்தி: பராயணம்|| 62 <br />
  <br />
  சுபாங்க: சாந்தித: ஸ்ரஷ்டா<br /> குமுத: குவலேசய:|<br />
  கோஹிதோ கோபதிர் கோப்தா<br /> வ்ருஷபாக்ஷோ வ்ருஷப்ரிய:|| 63 <br />
  <br />
  அநிவர்த்தீ நிவ்ருத்தாத்மா<br /> ஸம்க்ஷேப்தா க்ஷேமக்ருச்சிவ:|<br />
  ஸ்ரீவத்ஸவக்ஷா: ஸ்ரீவாஸ <br />ஸ்ரீபதி: ஸ்ரீமதாம்வர:|| 64<br /><br />
  ஸ்ரீத: ஸ்ரீச: ஸ்ரீநிவாஸ:<br /> ஸ்ரீநிதி: ஸ்ரீவிபாவந:|<br />
  ஸ்ரீதர: ஸ்ரீகர: ச்ரேய: <br />ஸ்ரீமாந் லோகத்ரயாச்ரய:|| 65 <br />
  <br />
  ஸ்வக்ஷ: ஸ்வங்க சதாநந்தோ<br /> நந்திர் ஜ்யோதிர் கணேச்வர:|<br />
  விஜிதாத்மா விதேயாத்மா<br /> ஸத்கீர்த்திச் சிந்நஸம்சய:|| 66 <br /><br />
  உதீர்ண: ஸர்வதஸ்சக்ஷுர்<br /> அநீச: சாச்வதஸ்திர:| <br />
  பூசயோ பூஷணோ பூதிர் <br />அசோக: சோகநாசந:|| 67<br />
  <br />
  அர்ச்சிஷ்மாநர்ச்சித: கும்போ<br /> விசுத்தாத்மா விசோதந:|<br />
  அநிருத்தோ-ப்ரதிரத: <br />ப்ரத்யும்நோ-மிதவிக்ரம:|| 68 <br />
  <br />
  காலநேமிநிஹா வீர:<br /> சௌரி:சூரஜநேச்வர: |<br />
  த்ரிலோகாத்மா த்ரிலோகேச:<br /> கேசவ: கேசிஹா ஹரி:|| 69 <br />
  <br />
  காமதேவ: காமபால: <br />காமீகாந்த: க்ருதாகம:| <br />
  அநிர்தேச்யவபுர்விஷ்ணுர் <br />வீரோநந்தோ தநஞ்ஜய:|| 70 <br />
  <br />
  ப்ரஹ்மண்யோ ப்ரஹ்மக்ருத்ப்ரஹ்மா<br /> ப்ரஹ்ம ப்ரஹ்ம விவர்தந:|<br />
  ப்ரஹ்மவித் ப்ராஹ்மணோ ப்ரஹ்மீ <br />ப்ரஹ்மஜ்ஞோ ப்ராஹ்மண ப்ரிய:|| 71<br /><br />
  மஹாக்ரமோ மஹாகர்மா<br /> மஹாதேஜா மஹோரக: |<br />
  மஹாக்ரதுர் மஹாயஜ்வா<br /> மஹாயஜ்ஞோ மஹாஹவி:|| 72 <br />
  <br />
  ஸ்தவ்ய: ஸ்தவப்ரிய: ஸ்தோத்ரம்<br /> ஸ்துதி:ஸ்தோதாரண ப்ரிய:|<br />
  பூர்ண: பூரயிதா புண்ய:<br /> புண்யகீர்த்திரநாமய:|| 73 <br />
  <br />
  மநோஜவஸ் தீர்த்தகரோ<br /> வஸுரேதா வஸுப்ரத:|<br />
  வஸுப்ரதோ வாஸுதேவோ<br /> வஸுர்வஸுமநாஹவி:|| 74 <br /><br />
  ஸத்கதி: ஸத்க்ருதி: ஸத்தா<br /> ஸத்பூதி: ஸத்பராயண:|<br />
  சூரஸேநோ யதுச்ரேஷ்ட:<br /> ஸந்நிவாஸ: ஸுயாமுந:|| 75 <br />
  <br />
  பூதாவாஸோ வாஸுதேவ:<br /> ஸர்வாஸுநிலயோநல:|<br />
  தர்ப்பஹா தர்பதோ-த்ருப்தோ<br /> துர்தரோ-தாபராஜித:|| 76 <br /><br />
  விச்வமூர்த்திர் மஹாமூர்ததிர்<br /> தீப்தமூர்த்திரமூர்த்திமாந்|<br />
  அநேகமூர்த்திரவ்யக்த:<br /> சதமூர்த்தி: சதாநந:|| 77 <br /><br />
  ஏகோநைக: ஸவ: க:கிம்<br /> யத்தத் பதமநுத்தமம்| <br />
  லோகபந்துர் லோகநாதோ<br /> மாதவோ பக்தவத்ஸல:|| 78 <br /><br />
  ஸுவர்ணவர்ணோ ஹேமாங்கோ<br /> வராங்கச் சந்தநாங்கதீ|<br />
  வீரஹா விஷம: சூந்யோ<br /> க்ருதாசீரசலச்சல:|| 79 <br />
  <br />
  அமாநீமாநதோ மாந்யோ<br /> லோகஸ்வாமீ த்ரிலோகத்ருத்|<br />
  ஸுமேதா மேஜோ தந்ய:<br /> ஸத்யமேதா தராதர:|| 80 <br />
  <br />
  தோஜோவ்ருஷோ த்யுதிதர:<br /> ஸர்வசஸ்த்ர ப்ருதாம்வர:|<br />
  ப்ரக்ரஹோ நிக்ரஹோ வ்யக்ரோ<br /> நைகச்ருங்கோ கதாக்ரஜ:|| 81 <br />
  <br />
  சதுர்மூர்த்திச்சதுர்பாஹுச்<br /> சதுர்வ்யூஹச்சதுர்கதி:|<br />
  சதுராத்மா சதுர்பாவச்<br /> சதுர்வேதவிதேகபாத்|| 82 <br />
  <br />
  ஸமாவர்த்தோ நிவ்ருத்தாத்மா<br /> துர்ஜயோ துரதிக்ரம:|<br />
  துர்லபோ துர்கமோ துர்கோ<br /> துராவாஸோ துராரிஹா|| 83 <br /><br />
  சுபாங்கோ லோகஸாரங்க:<br /> ஸுதந்துஸ் தந்துவர்த்தந:|<br />
  இந்த்ரகர்மா மஹாகர்மா<br /> க்ருதகர்மா க்ருதாகம:|| 84 <br />
  <br />
  உத்பவ: ஸுந்தர: ஸுந்தோ<br /> ரத்நநாப: ஸுலோசந:|<br />
  அர்க்கோ வாஜஸநச்ருங்கீ<br /> ஜயந்த: ஸர்வவிஜ்ஜயீ|| 85<br /><br />
  ஸுவர்ணபிந்து ரக்ஷோப்ய:<br /> ஸர்வவாகீச்வரேச்வர:|<br />
  மஹாஹ்ரதோ மஹாகர்த்தோ<br /> மஹாபூதோ மஹாநிதி:|| 86 <br />
  <br />
  குமுத: குந்தர: குந்த: <br />பர்ஜந்ய: பாவநோ-நில:|<br />
  அம்ருதாசோஅம்ருதவபு:<br /> ஸர்வஜ்ஞ: ஸர்வதோமுக:|| 87 <br /><br />
  ஸுலப: ஸுவ்ரத: ஸித்த:<br /> சத்ருஜித் சத்ருதாபந:|<br />
  ந்யக்ரோதோ தும்பரோஅச்வத்தச்<br /> சாணுாராந்த்ர நிஷஷூதந:|| 88 <br />
  <br />
  ஸஹஸ்ரார்ச்சி: ஸப்தஜிஹ்வ:<br /> ஸப்தைதா: ஸப்தவாஹந:|<br />
  அமூர்த்திரநகோஅசிந்த்யோ <br />பயக்ருத் பயநாசந:|| 89 <br />
  <br />
  அணுர்ப்ருஹத் க்ருச: ஸ்தூலோ<br /> குணப்ருந் நிர்குணோமஹாந்|<br />
  அத்ருத: ஸ்வத்ருத ஸ்வாஸ்ய:<br /> ப்ராக்வம்சோ வம்ச வர்தந:|| 90 <br /><br />
  பாரப்ருத் கதிதோ யோகீ<br /> யோகீச: ஸர்வகாமத:|<br />
  ஆச்ரம: ச்ரமண க்ஷாம:<br /> ஸுபர்ணோ வாயுவாஹந:|| 91 <br />
  <br />
  தநுர்தரோ தநுர்வேதோ<br /> தண்டோ தமயிதா-தம:|<br />
  அபராஜித: ஸர்வஸஹோ<br /> நியந்தா நியமோயம:|| 92 <br /><br />
  ஸத்வவாந் ஸாத்விக: ஸத்ய:<br /> ஸத்யதர்மபராயண:|<br />
  அபிப்ராய: ப்ரியார்ஹோர்ஹ:<br /> ப்ரியக்ருத் ப்ரீதிவர்த்தந:|| 93 <br />
  <br />
  விஹாயஸகதிர் ஜ்யோதி:<br /> ஸுருசிர் ஹுதபுக்விபு:|<br />
  ரவிர்விரோசந: ஸூர்ய:<br /> ஸவிதாரவிலோசந: || 94 <br /><br />
  அநந்தஹுத புக்போக்தா<br /> ஸுகதோ நைகதோஅக்ரஜ:|<br />
  அநிர்விண்ண: ஸதாமர்ஷீ <br />லோகாதிஷ்டாநமத்புத:|| 95 <br />
  <br />
  ஸநாத்ஸநாதநதம: <br />கபில: கபிரவ்யய:|<br />
  ஸ்வஸ்தித: ஸ்வஸ்திக்ருத் ஸ்வஸ்தீ<br /> ஸ்வஸ்திபுக் ஸ்வஸ்தி தக்ஷிண:|| 96 <br />
  <br />
  அரௌத்ர: குண்டலீ சக்ரீ <br />விக்ரம்யூர் ஜிதசாஸந:|<br />
  சப்தாதிக: சப்தஸஹ:<br /> சிசிர: சர்வரீகர:|| 97 <br />
  <br />
  அக்ரூர: பேசலோ தக்ஷோ<br /> தக்ஷிண: க்ஷமிணாம்வர:|<br />
  வித்வத்தமோ வீதபய:<br /> புண்யச்ரவண கீர்த்தந:|| 98<br />
  <br />
  உத்தாரணோ துஷ்க்ருதிஹா<br /> புண்யோ துஸ்வப்ந நாசந:|<br />
  வீரஹா ரக்ஷண: ஸந்தோ<br /> ஜீவந: பர்யவஸ்தித:|| 99<br /><br />
  அநந்தரூபோஅநந்தஸ்ரீ:<br /> ஜிதமந்யுர் பயாபஹ:|<br />
  சதுரச்ரோ கபீராத்மா <br />விதிசோ வ்யாதிசோ திச:|| 100<br /><br />
  அநாதிர் பூர்புவோலக்ஷ்மீ:<br /> ஸுவீரோ ருசிராங்கத:|<br />
  ஜநநோ ஜநஜந்மாதிர்<br /> பீமோபீமபராக்ரம:|| 101<br /><br />
  ஆதாரநிலயோ தாதா<br /> புஷ்பஹாஸ: ப்ரஜாகர:|<br />
  ஊர்த்வக: ஸத்பதாசார:<br /> ப்ராணத ப்ரணவ: பண:|| 102<br /><br />
  ப்ரமாணம் ப்ராணநிலய:<br /> ப்ராணப்ருத் ப்ராண ஜீவந:|<br />
  தத்வம் தத்வவிதேகாத்மா<br /> ஜந்ம ம்ருத்யுஜராதிக:|| 103<br /><br />
  பூர்புவ:ஸ்வஸ்தருஸ்தாரஸ்<br /> ஸவிதா ப்ரபிதாமஹ:|<br />
  யஜ்ஞோ யஜ்ஞபதிர் யஜ்ஞ்வா<br /> யஜ்ஞாங்கோ யஜ்ஞவாஹன:|| 104<br /><br />
  யஜ்ஞப்ருத் யஜ்ஞக்ருத் யஜ்ஜீ <br />யஜ்ஞபுக் யஜ்ஞஸாதன:|<br />
  யஜ்ஞாந்தக்ருத் யஜ்யுகுஹ்யம்<br /> அந்நமந்நாத ஏவ ச|| 105<br /><br />
  ஆத்மயோநி: ஸ்வயஜ்ஞாதோ<br /> வைகாந: ஸாமகாயந:| <br />
  தேவகீநந்தந: ஸ்ரஷ்டா<br /> க்ஷிதீச: பாபநாசந:|| 106<br /><br />
  சங்கப்ருந் நந்தகீ சக்ரீ<br /> சார்ங்கதந்வா கதாதர:| <br />
  ரதாங்கபாணி ரக்ஷோப்ய:<br /> ஸர்வப்ரஹரணாயுத: || 107<br /><br />
  ஸ்ரீஸர்வப்ரஹரணாயுத ஓம் நம இதி<br /><br />
  வநமாலீ கதீ சார்ங்கீ <br />சங்கீ சக்ரீ ச நந்தகீ|<br />
  ஸ்ரீமாந் நாராயணோ விஷ்ணுர்<br /> வாஸுதேவோஅபிரக்ஷது||(2) 108<br />
  <br />
  <br />
  பலச்ருதி:<br />
  இதீதம் கீர்த்தநீயஸ்ய <br />கேசவஸ்ய மஹாத்மந:|<br />
  நாம்நாம் ஸஹஸ்ரம் திவ்யாநாம் <br />அசேஷண ப்ரகீர்த்திதம்|| 1<br /><br />
  ய இதம் ச்ருணுயாந்நித்யம் <br />யச்சாபி பரிகீர்த்தயேத்|<br />
  நாசுபம் ப்ராப்நுயாத் கிஞ்சித்<br /> ஸோ-முத்ரேஹசமானவ:|| 2<br /><br />
  வேதாந்தகோ ப்ராஹ்மண:ஸ்யாத்<br /> க்ஷத்ரியோ விஜயீபவேத்|<br />
  வைச்யோ தநஸம்ருத்த: ஸ்யாச்<br /> சூத்ர: சுகம் அவாப்நுயாத்|| 3<br /><br />
  தர்மார்த்தீ ப்ராப்நுயாத் தர்மம்<br /> அர்த்தார்த்தீ சார்த்தம் ஆப்நுயாத்|<br />
  காமாநவாப்நுயாத் காமீ<br /> ப்ரஜார்த்தீ ப்ராப்நுயாத் ப்ரஜா:|| 4<br /><br />
  பக்திமாந் ய: ஸதோத்தாய<br /> சுசிஸ் தத்கதமாநஸ:| <br />
  ஸஹஸ்ரம் வாஸுதேவஸ்ய<br /> நாம்நாமேதத் ப்ரகீர்த்தயேத்|| 5<br /><br />
  யச: ப்ராப்நோதி விபுலம்<br /> ஜ்ஞாதி ப்ராதாந்யமேவ ச |<br />
  அசலாம் ச்ரியமாப்நோதி<br /> ச்ரேய: ப்ராப்நோத்ய நுத்தமம்|| 6<br />
  நபயம் க்வசிதாப்நோதி <br />வீர்யம் தேஜஸ்ச்ச விந்ததி |<br />
  பவத்யரோகோ த்யுதிமாந் <br />பலரூபகுணாந்வித: || 7<br />
  ரோகார்த்தோ முச்யதே ரோகாத்<br /> பத்தோ முச்யேத பந்தநாத் |<br />
  பயாந்முச்யேத பீதஸ்த்து <br />முச்யேதாபந்ந ஆபத: || 8<br />
  துர்காண்யதி தரத்யாசு<br /> புருஷ: புருஷோத்தமம் |<br />
  ஸ்துவந் நாம ஸஹஸ்ரேண<br /> நித்யம் பக்திஸமந்வித: || 9<br />
  வாஸுதேவாச்ரயோ மர்த்யோ<br /> வாஸுதேவ பராயண: |<br />
  ஸர்வபாப விசுத்தாத்மா<br /> யாதி ப்ரஹ்ம ஸநாதநம் || 10<br />
  ந வாஸுதேவ பக்தாநாம்<br /> அசுபம் வித்யதே க்வசித் |<br />
  ஜந்ம ம்ருத்யு ஜராவ்யாதி <br />பயம் நைவோபஜாயதே || 11<br />
  இமம் ஸ்தவமதீயாந:<br /> ச்ரத்தா பக்தி ஸமந்வித: |<br />
  யுஜ்யேதாத்மா ஸுகக்ஷாந்தி<br /> ஸ்ரீத்ருதி ஸ்ம்ருதிகீர்த்திபி: || 12<br />
  நக்ரோதோ நச மாத்ஸர்யம்<br /> நலோபோ நாசுபாமதி: |<br />
  பவந்தி க்ருத புண்யாநாம்<br /> பக்தாநாம் புருஷோத்தமே || 13<br />
  த்யௌஸ்ஸசந்த்ரார்க்க நக்ஷத்ரா<br /> கம்திசோபூர் மஹோததி: |<br />
  வாஸுதேவஸ்ய வீர்யேண<br /> வித்ருதாநி மஹாத்மந: || 14<br />
  ஸஸுராஸுரகந்தர்வம்<br /> ஸயக்ஷோரகராக்ஷஸம் |<br />
  ஜகத்வசேவர்த்ததேதம்<br /> க்ருஷ்ணஸ்ய ஸசராசரம் || 15<br />
  இந்த்ரியாணி மநோபுத்தி:<br /> ஸத்வம் தேஜோபலம் த்ருதி:|<br />
  வாஸுதேவாத் மகாந்யாஹு:<br /> க்ஷேத்ரம் க்ஷேத்ரஜ்ஞ ஏவ ச|| 16<br />
  ஸர்வாகமாநாமாசார:<br /> ப்ரதமம் பரிகல்பிதே |<br />
  ஆசார ப்ரபவோ தர்மோ<br /> தர்மஸ்ய ப்ரபுரச்யுத: || 17<br />
  ருஷய: பிதரோ தேவோ<br /> மஹாபூதாநி தாதவ: |<br />
  ஜங்கமா ஜங்கமஞ்சேதம்<br /> ஜகந்நாரயணோத்பவம் || 18<br />
  யோகோஜ்ஞானம் ததா ஸாங்க்யம்<br /> வித்யா: சில்பாதி கர்ம ச |<br />
  வேதா: சாஸ்த்ராணி விஜ்ஞானம்<br /> ஏதத் ஸர்வம் ஜநார்தநாத் || 19<br />
  ஏகோவிஷ்ணுர் மஹத்பூதம் <br />ப்ருதக்பூதாந்யநேகச: |<br />
  த்ரீந்லேகாந் வ்யாப்த பூதாத்மா<br /> புங்க்தே விச்வபுகவ்யய: || 20<br />
  இமம் ஸ்தவம் பகவதோ<br /> விஷ்ணோர் வ்யாஸேந கீர்த்திதம்| <br />
  படேத்ய இச்சேத் புருஷ:<br /> ச்ரேய: ப்ராப்தும் ஸுகாநி ச || 21<br />
  விச்வேச்வரமஜம்தேவம்<br /> ஜகத: ப்ரபுரவ்யயம் |<br />
  பஜந்தியே புஷ்கராக்ஷம்<br /> ந தே யாந்தி பராபவம் || 22<br />
  நதேயாந்தி பராபவம் ஓம் நம இதி<br />
  அர்ஜுந உவாச-<br />
  பத்மபத்ர விசாலக்ஷ <br />பத்மநாப ஸுரோத்தம |<br />
  பக்தாநாமநுரக்தாநாம்<br /> த்ராதா பவ ஜநார்தந| || 23 <br />
  ஸ்ரீ பகவாநுவாச-<br />
  யோமாம் நாம ஸஹஸ்ரேண<br /> ஸ்தோதுமிச்சதி பாண்டவ |<br />
  ஸோ-ஹமேகேந ச்லோகேந<br /> ஸ்துதஏவ ந ஸம்சய: || 24<br />
  ஸ்துத ஏவ ந ஸம்சய ஓம் நம இதி<br />
  வ்யாஸ உவாச-<br />
  வாஸநாத் வாஸுதேவஸ்ய <br />வாஸிதம் தே ஜகத் த்ரயம்| <br />
  ஸர்வபூதநிவாஸோஸி<br /> வாஸுதேவ நமோஸ்துதே|| 25<br />
  ஸ்ரீ வாசுதேவ நமோஸ்துத ஓம் நம இதி<br />
  பார்வத்யுவாச-<br />
  கேநோபாயேந லகுநா <br />விஷ்ணோர் நாம ஸஹஸ்ரகம்|<br />
  பட்யதே பண்டிதைர் நித்யம்<br /> ச்ரோதுமிச்சாம்யஹம் ப்ரபோ|| 26<br />
  ஈச்வர உவாச-<br />
  ஸ்ரீராம ராம ராமேதி<br /> ரமே ராமே மநோரமே|<br />
  ஸஹஸ்ரநாம தத்துல்யம்<br /> ராமநாம வராநநே||(2) 27<br />
  ஸ்ரீராம நாம வராநந ஓம் நம இதி<br />
  ப்ரஹ்மோவாச-<br />
  நமோஸ்த்வநந்யாய <br />ஸஹஸ்ர மூர்த்தயே| 28<br />
  ஸஹஸ்ரபாதாக்ஷி <br />சிரோருபாஹவே|| <br />
  ஸஹஸ்ர நாம்நே <br />புருஷாய சாச்வதே|<br />
  ஸஹஸ்ரகோடி<br /> யுகதாரிணே நம:|| 29<br />
  ஸ்ரீ ஸஹஸ்ரகோடி <br />யுகதாரிண ஓம் நம இதி<br />
  ஸஞ்ஜய உவாச-<br />
  யத்ரயோகேச்வர: க்ருஷ்ணோ<br /> யத்ரபார்த்தோ தநுர்தர:|<br />
  தத்ர ஸ்ரீர்விஜயோ பூதி:<br /> த்ருவா நீதிர் மதிர் மம|| 30<br />
  ஸ்ரீபகவாநுவாச-<br />
  அநந்யாச்சிந்தயந்தோமாம்<br /> யே ஜநா: பர்யுபாஸதே| <br />
  தேஷாம் நித்யாபியுக்தாநாம்<br /> யோகக்ஷேமம் வஹாம்யஹம்|| 31<br />
  பரித்ராணாய ஸாதூநாம்<br /> விநாசாய ச துஷ்க்ருதாம்|<br />
  தர்ம ஸம்ஸ்தாபநார்த்தாய<br /> ஸம்பவாமி யுகே யுகே|| 32<br />
  ஆர்த்தா விஷண்ணா: சிதிலாச்ச பீதா:<br /> கோரேஷு வ்யாதிஷு வர்தமாநா:|<br />
  ஸங்கீர்த்ய நாராயண சப்தமாத்ரம்<br /> விமுக்த துக்கா: ஸுகிநோ பவந்து|| 33<br />
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>04- ஹயக்ரீவ ஸ்தோத்திரம்   
    </mat-expansion-panel-header>
    <div class="div3">
      ஹயக்ரீவ ஸ்தோத்திரம்<br><br>

      ஸ்ரீமாந் வேங்கட நாதார்ய:<br> கவிதார்க்கிச கேஸரீ <br>
      வேதாந்ததாச்சார்யவர்யோமே ஸந்நிதத்தாம் ஸதாஹ்ருதி<br><br>
      
      ஜ்ஞானாநந்தமயம் தேவம்<br> நிர்மலஸ்படிகாக்ருதிம்<br>
      ஆதாரம் ஸர்வ வித்யாநாம்<br> ஹயக்ரீவமுபாஸ்மஹே			1<br><br>
      
      ஸ்வதஸ்ஸித்தம் ஸுத்தஸ்படிக<br> மணிபூப்ருத் ப்ரதிபடம்<br>
      ஸுதா ஸத்ரீசீபிர் <br>த்யுதிபிரவதாத த்ரிபுவநம்<br>
      அநந்தைஸ்த்ரய்யந்தை <br>ரநுவிஹிதஹேஷா ஹலஹலம்<br>
      ஹதாஸேஷாவத்யம் <br>ஹயவதநமீடீமஹி மஹ:				2<br><br>
      
      ஸமாஹாரஸ் ஸாம்நாம்<br> ப்ரதிபதம்ருசாம் தாம யஜுஷாம்<br>
      லய: ப்ரத்யூஹாநாம் <br>லஹரிவிததிர் போதஜலதே:<br>
      கதாதர்ப்பக்ஷப்யத்தககுல<br> கோலாஹலபவம்<br>
      ஹரத்வந்தர்த்வாந்தம் <br>ஹயவதந ஹேஷாஹலஹல:			3<br><br>
      
      ப்ராசீ ஸந்த்யா <br>காசிதந்தர் நிஸாயா:<br>
      ப்ரஜ்ஞாத்ருஷ்டேரஞ்ஜந<br> ஸ்ரீரபூர்வா<br>
      வக்த்ரீ வேதாந் <br>பாது மே வாஜிவக்த்ரா<br>
      வாகீஸாக்யா <br>வாஸுதேவஸ்ய மூர்த்தி:					4<br><br>
      
      விஸுத்த விஜ்ஞாந<br> கநஸ்வரூபம்<br>
      விஜ்ஞாந விஸ்ராணந<br> பத்ததீக்ஷம்<br>
      தயாநிதிம் தேஹப்ருதாம்<br> ஸரண்யம்<br>
      தேவம் ஹயக்ரீவமஹம் <br>ப்ரபத்யே					5<br><br>
      
      அபௌருஷேயைரபி வாக்ப்ரபஞ்சை:<br>
      அத்யாபி தே பூதிமத்ருஷ்டபாராம்<br>
      ஸ்துவந்நஹம் முக்த இதி த்வயைவ<br>
      காருண்யதோ நாத கடாக்ஷணீய:					6<br><br>
      
      தாக்ஷிண்யரம்யா கிரிஸஸ்ய மூர்த்தி:<br>
      தேவீ ஸரோஜாஸந தாமபத்நீ<br>
      வ்யாஸாதயோzபி வ்யபதேஸ்ய வாச:<br>
      ஸ்புரந்தி ஸர்வே தவ ஸக்திலேஸை:					7<br><br>
      
      மந்தோzபவிஷ்யந்நியதம் விரிஞ்சோ<br>
      வாசாம்நிதே வஞ்சித பாகதேய:<br>
      தைத்யாபநீதாந் தயயைவ பூயோzபி<br>
      அத்யாபயிஷ்யோ நிகமாந் நசேத் த்வம்				8<br><br>
      
      விதர்க்க டோலாம் வ்யவதூய ஸத்வே<br>
      ப்ருஹஸ்பதிம் வர்த்தயஸே யதஸ்த்வம்<br>
      தேநைவ தேவ த்ரிதஸேஸவராணாம்<br>
      அஸ்ப்ருஷ்ட டோலாயிதமாதிராஜ்யம்					9<br><br>
      
      அக்நௌ ஸமித்தார்ச்சிஷி ஸப்ததந்தோ:<br>
      ஆதஸ்திவாந் மந்த்ரமயம் ஸரீரம்<br>
      அகண்ட ஸாரைர்ஹவிஷாம் ப்ரதாநை:<br>
      ஆப்யாயநம் வ்யோமஸதாம்விதத்ஸே					10<br><br>
      
      யந்மூலமீத்ருக ப்ரதிபாதி தத்வம்<br>
      யா மூலமாம்நாய மஹத்ருமாணாம்<br>
      தத்வேந ஜாநந்தி விஸுத்தஸத்வா:<br>
      த்வாமக்ஷராமக்ஷரமாத்ருகாம் தே					11<br><br>
      
      அவ்யாக்ருதாத் வ்யாக்ருதவாநஸி த்வம்<br>
      நாமாநி ரூபாணி ச யாநி பூர்வம்<br>
      ஸம்ஸந்தி தேஷாம் சரமாம் ப்ரதிஷ்டாம்<br>
      வாகீஸ்வர த்வாம் த்வதுபஜ்ஞவாச:					12<br><br>
      
      முக்தேந்து நிஷ்யந் விலோபநீயாம்<br>
      மூர்த்திம் தவாநந்த ஸுதாப்ரஸூதிம்<br>
      விபஸ்சிதஸ்சேதஸி பாவயந்தே<br>
      வேலாமுதாராமிவ துக்தஸிந்தோ:					13<br><br>
      
      மநோகதம் பஸ்யதி ய: ஸதா த்வாம்<br>
      மநீஷிணாம்மாநஸ ராஜஹம்ஸம்<br>
      ஸ்வயம் புரோபாவ விவாத பாஜ:<br>
      கிங்குர்வதே தஸ்ய கிரோ யதார்ஹம்					14<br><br>
      
      அபி க்ஷணார்த்தம் கலயந்தி யே த்வாம்<br>
      ஆப்லாவயந்தம் விஸதைர்மயூகை:<br>
      வாசாம் ப்ரவாஹைரநிவாரிதைஸ்தே<br>
      மந்தாகிநீம் மந்தயிதும் க்ஷமந்தே					15<br><br>
      
      ஸ்வாமிந் பவத் த்யான ஸுதாபிஷேகாத்<br>
      வஹந்தி தந்யா: புலகாநுபந்தம்<br>
      அலக்ஷிதே க்வாபி நிரூடமூலம்<br>
      அங்கேஷ்விவாந்ந்ததும் அங்குரந்தம்					16<br><br>
      
      ஸ்வாமிந் ப்ரதீசா ஹ்ருதயேந தந்யா:<br>
      த்வத்த்யாந சந்த்ரோதய வர்த்தமாநம்<br>
      அமாந்தமாநந்த பயோதிமந்த:<br>
      பயோபிரக்ஷணாம் பரிவாஹயந்தி					17<br><br>
      
      ஸ்வைராநுபாவாஸ்த்வததீந பாவா:<br>
      ஸம்ருத்தவீர்யாஸ்த்வதநுக்ரஹேண<br>
      விபஸ்சிதோ நாத தரந்தி மாயாம்<br>
      வைஹாரிகீம் மோஹநபிஞ்சிகாம் தே					18<br><br>
      
      ப்ராங்நிர்மிதாநாம் தபஸாம் விபாகா:<br>
      ப்ரத்யக்ரநிஸ்ரேயஸஸம்பதோ மே<br>
      ஸமேதிஷீரம்ஸ்தவ பாதபத்மே<br>
      ஸங்கல்ப சிந்தாமணய: ப்ராணாமா:					19<br><br>
      
      விலுப்த மூர்த்தந்ய லிபிக்ரமாணாம்<br>
      ஸுரேந்த்ர சூடாபத லாலிதாநாம்<br>
      த்வதங்க்ரி ராஜீவரஜ: கணாநாம்<br>
      பூயாந் ப்ரஜாதோ மயி நாத பூயாத்					20<br><br>
      
      பரிஸ்ப்புரந் நூபுர சித்ர சித்ரபாநு<br>
      ப்ரகாஸ நிர்த்தூத தமோநுஷங்காம்<br>
      பதத்வயீம் தே பரிசிந்மஹேந்த:<br>
      ப்ரபோதராஜீவ விபாத ஸந்த்யாம்					21<br><br>
      
      த்வத்கிங்கராலங்கரணோசிதாநாம்<br>
      த்வயைவ கல்பாந்தர பாலிதாநாம்<br>
      மஞ்ஜுப்ரணாதம் மணிநூபுரம் தே<br>
      மஞ்ஜூஷிகாம் வேதகிராம் ப்ரதீம:					22<br><br>
      
      ஸஞ்சிந்தயாமி ப்ரதிபாதஸஸாஸ்தாந்<br>
      ஸந்துக்ஷயந்தம் ஸமய ப்ரதீபாந்<br>
      விஜ்ஞ்ந கல்பத்ரும பல்லவாபம்<br>
      வ்யாக்யாந முத்ரா மதுரம் கரம் தே					23<br><br>
      
      சித்தே கரோமி ஸ்புரிதாக்ஷமாலம்<br>
      ஸவ்யேதரம் நாத கரம் த்வதீயம்<br>
      ஜ்ஞாநாம்ருதோதஞ்சந லம்படாநாம்<br>
      லீலா கடீயந்த்ரமிவாஸ்ரிதாநாம்						24<br><br>
      
      ப்ரபோத ஸிந்தோரருணை: ப்ரகாஸை:<br>
      ப்ரவால ஸங்காதமிவோத்வஹந்தம்<br>
      விபாவயே தேவ ஸபுஸ்தகம்தே<br>
      வாமம் கரம் தக்ஷிணமாஸ்ரிதாநாம்					25<br><br>
      
      தமாம்ஸி பித்வா விஸதைர்மயூகை:<br>
      ஸம்ப்ரீணயந்தம் விதுஷஸ்சகோராந்<br>
      நிஸாமயே த்ராம் நவபுண்டாிகே<br>
      ஸரத்கநே சந்த்ரமிவ ஸ்புரந்தம்						26<br><br>
      
      திஸந்து மே தேவ ஸதாத்வதீயா:<br>
      தயாதரங்காநுசரா: கடாக்ஷh:<br>
      ஸ்ரோத்ரேஷு பும்ஸாமம்ருதம் க்ஷரந்தீம்<br>
      ஸரஸ்வதீம் ஸம்ஸ்ரித காமதேநும்					27<br><br>
      
      விஸேஷவித்பாரிஷதேஷு நாத<br>
      விதக்த கோஷ்டீ  ஸமராங்கணேஷு<br>
      ஜிகீஷதோ மே கவிதார்க்கிகேந்த்ராந்<br>
      ஜிஹ்வாக்ர ஸிம்ஹாஸநமப்யுபேயா:					28<br><br>
      
      த்வாம் சிந்தயந் த்வந்மயதாம் ப்ரபந்த:<br>
      த்வாமுத்க்ருணந் ஸப்தமயேந தாம்நா<br>
      ஸ்வாமிந் ஸமாஜேஷு ஸமேதிஷீய<br>
      ஸ்வச்சந்த வாதாஹவ பத்தஸூர:					29<br><br>
      
      நாநாவிதாநாமகதி: கலாநாம்<br>
      நசாபி தீர்த்தேஷு க்ருதாவதார:<br>
      த்ருவம் தவாநாத பரிக்ரஹாயா:<br>
      நவம் நவம் பாத்ரமஹம் தயாயா:						30<br><br>
      
      அகம்பநீயாந்யபநீதி பேதை:<br>
      அலங்க்ருஷீரந் ஹ்ருதயம் மதீயம்<br>
      ஸங்கா களங்காபகமோஜ்வலாநி<br>
      தந்வாநி ஸம்யஞ்சி தவ ப்ரஸாதாத்					31<br><br>
      
      வ்யாக்யா முத்ராம் கரஸரஸிஜை: புஸ்தகம் ஸங்கசக்ரே<br>
      பிப்ரத்பிந்ந ஸ்படிகருசிரே புண்டாிகே நிஷண்ண:<br>
      அம்லாநஸ்ரீரம்ருதவிஸதைரம்ஸுபி:  ப்லாவயந்மாம்<br>
      ஆவிர்பூயாதநக மஹிமா மாநஸேவாகதீஸ:				32<br><br>
      
      வாகர்த்த ஸித்திஹேதோ:<br>
      படத ஹயக்ரீவ ஸம்ஸ்துதிம் பக்த்யா<br>
      கவிதார்க்கிககேஸரிணா<br>
      வேங்கடநாதேந விரசிதாமேதாம்					33<br><br>
      
      
      கவிதார்க்கிகஸிம்ஹாய கல்யாணகுண ஸாலிநே<br>
      ஸ்ரீமதே வேங்கடாஸாய வேதாந்த குரவே நம:<br> 
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>      
    </mat-expansion-panel-header>
    <div class="div3"></div>
  </mat-expansion-panel>
</mat-accordion>`;

const SthothramsPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ஸ்தோத்திரங்கள்  - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default SthothramsPage;
